import { IProjectTemplate } from '@d-id/types';
import { useMemo } from 'react';

export const useTemplatesTagList = (templates: IProjectTemplate[]) => {
    return useMemo(
        () =>
            Array.from(
                new Set(
                    templates
                        .map(template => template.tags)
                        .flat()
                        .filter(tag => !!tag.trim())
                )
            ),
        [templates]
    );
};
